// Vampire/gothic themed words for session codes (2-4 characters)
const themedWords = [
  // 2-character codes
  "VV", // double V for vampire
  "XV", // ex-vampire
  "ZZ", // sleeping sound

  // 3-character codes
  "BAT",
  "FAN",
  "FOG",
  "RED",
  "VIP",
  "COW",
  "OWL",
  "WEB",
  "DEN",
  "BOO",
  "VEX",
  "HEX",
  "ZAP",
  "ZOO",
  "GEM",
  "ICE",
  "INK",
  "JAW",
  "KEY",
  "LAB",
  "MAD",
  "NAP",
  "ODD",
  "PAW",
  "RAT",
  "SLY",
  "TAP",
  "URN",

  // 4-character codes
  "BITE",
  "FANG",
  "DARK",
  "MOON",
  "CLAW",
  "MIST",
  "TOMB",
  "CAPE",
  "LAIR",
  "DOOM",
  "GRIM",
  "PALE",
  "DUSK",
  "DAWN",
  "BONE",
  "SOUL",
  "GOTH",
  "NOIR",
  "DRAC",
  "VLAD",
  "HYDE",
  "BATS",
  "WOLF",
  "DEAD",
  "FEAR",
  "LURK",
  "VAMP",
  "NECK",
  "VEIN",
  "SUCK",
  "HISS",
  "PREY",
  "CULT",
  "OMEN",
  "EVIL",
  "GORE",
  "WAIL",
];

export const generateSessionName = () => {
  // Pick a random themed word from the list
  const randomWord =
    themedWords[Math.floor(Math.random() * themedWords.length)];
  // Ensure it's uppercase and truncate to 4 characters max
  return randomWord.toUpperCase().substring(0, 4);
};
